import { render, staticRenderFns } from "./MedicalInsuranceLevelsTable.vue?vue&type=template&id=bfddacea&"
import script from "./MedicalInsuranceLevelsTable.vue?vue&type=script&lang=js&"
export * from "./MedicalInsuranceLevelsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports